import { render, staticRenderFns } from "./FiltratePad.vue?vue&type=template&id=19881e26&scoped=true"
import script from "./FiltratePad.vue?vue&type=script&lang=js"
export * from "./FiltratePad.vue?vue&type=script&lang=js"
import style0 from "./FiltratePad.vue?vue&type=style&index=0&id=19881e26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19881e26",
  null
  
)

export default component.exports